import React from "react";
import ApiService from "../../../Services/ApiService";
import queryString from "query-string";
import UploadImage from "../ads/uploadImage.js";
import AudienceForm from "../audience/audienceForm";
import ReactTable from "react-table";

class Account extends React.Component {

    // default state
    state = {
        data: {
            client_id: "",
            campaign_id: "",
            linkedin_company_id: "",
            linkedin_url: "",
            account_owner: "",
            default_name: "",
            common_name: "",
            file_identifier: "",
            job_functions: [],
            seniorities: [],
            locations: [],
            audience_size: "Calculating...",
            bid_amount: "",
            table_data: [],
            table_loading: true,
            ranking: true,
            hide_audience_form: true,
            include_secondary_companies_changed: false,
            include_secondary_companies: false,
            image_a_url: '',
            image_b_url: '',
            unique_url: ''
        },
        form_dirty: false
    };

    componentDidMount() {

        let params = queryString.parse(this.props.location.search);
        if (params) {
            let clientId = params.client_id;
            let campaignId = params.campaign_id;
            let linkedinCompanyId = params.id;
            this.setState({
                data: {
                    ...this.state.data,
                    client_id: clientId,
                    campaign_id: campaignId,
                    linkedin_company_id: linkedinCompanyId
                }

            });

            this.setAudienceGroupOptions(campaignId, linkedinCompanyId);
            this.setCompanyNameAndAudience(campaignId, linkedinCompanyId);
        }
    }

    fetchAudienceSize = () => {
        ApiService.post('/api/linkedin/audience-size',
            {
                'linkedin_company_id': this.state.data.linkedin_company_id,
                'job_functions[]': this.state.data.job_functions,
                'seniorities[]': this.state.data.seniorities,
                'locations[]': this.state.data.locations,
                'client_id': this.state.data.client_id,
                'campaign_id': this.state.data.campaign_id
            }).then(response => {
                this.setState({
                    data: {
                        ...this.state.data,
                        audience_size: response.data.size
                    }
                });

        })
    };

    setCompanyNameAndAudience (campaignId, linkedinCompanyId) {
        ApiService.get('/api/campaigns/linkedin-companies?campaign_id=' + campaignId).then(response => {
            const companies = (response.data.Companies);
            let matchedCompany = companies.filter(function (el) {
                return el.campaign_id == campaignId && el.linkedin_company_id == linkedinCompanyId;
            });

            if (matchedCompany.length > 0) {
                matchedCompany = matchedCompany[0];

                const defaultName = matchedCompany.default_name;
                const commonName = matchedCompany.common_name;
                const fileIdentifier = matchedCompany.file_identifier;
                const linkedinURL = matchedCompany.linkedin_url;
                const accountOwner = matchedCompany.account_owner;
                const bidAmount = matchedCompany.bid_amount ?? 0;
                const datePublished = matchedCompany.date_published;
                const imageAUrl = matchedCompany.image_a_S3_url;
                const imageBUrl = matchedCompany.image_b_S3_url;
                const uniqueUrl = matchedCompany.unique_url;


                this.setState({data: {...this.state.data,
                        default_name: defaultName,
                        common_name: commonName,
                        file_identifier: fileIdentifier,
                        linkedin_url: linkedinURL,
                        account_owner:accountOwner,
                        bid_amount: bidAmount,
                        date_published: datePublished,
                        image_a_url: imageAUrl,
                        image_b_url: imageBUrl,
                        unique_url: uniqueUrl
                }});

                if (matchedCompany.job_functions[0] !== 'Default' && matchedCompany.seniorities[0] !== 'Default' && matchedCompany.locations[0] !== 'Default') {
                    this.setAccountSpecificAudience(matchedCompany)
                } else {
                    this.setDefaultAudienceOptions(campaignId);
                }
            }

        });
    }

    setAccountSpecificAudience = (companyData) => {
        let jobFunctions = companyData.job_functions;
        let seniorities = companyData.seniorities;
        let locations = companyData.locations;
        let audienceSize = companyData.audience_size;
        let includeSecondaryCompanies = companyData.secondary_companies;

        this.setState({data: {
                ...this.state.data,
                job_functions: jobFunctions,
                seniorities: seniorities,
                locations: locations,
                audience_size: audienceSize,
                hide_audience_form: false,
                include_secondary_companies: includeSecondaryCompanies
            }}, () => {
            if(audienceSize == 0) {
                this.fetchAudienceSize();
            }
        });
    }

    setDefaultAudienceOptions(campaignId) {
        const url = "/api/campaigns/fetch?campaign_id=" + campaignId;
        ApiService.get(url)
            .then(response => {
                let campaign = response.data.Campaign;
                if (campaign) {
                    this.setState({
                        data: {...this.state.data,
                            job_functions: campaign.job_functions,
                            seniorities: campaign.seniorities,
                            locations: campaign.locations,
                            hide_audience_form: false
                        }
                    }, () => {this.fetchAudienceSize();});
                }
            })
            .catch(error => {
                console.log(error);
            })
    }

    setAudienceGroupOptions(campaignId, linkedinCompanyId) {
        let campaign_id = parseInt(campaignId);
        let linkedin_company_id = parseInt(linkedinCompanyId);

        ApiService.get("/api/campaigns/fetch-linkedin-company-audience-options?campaign_id="+ campaign_id +"&linkedin_company_id="+linkedin_company_id)
            .then(response => {
                let data = JSON.parse(JSON.stringify(response.data.options));
                for (let i = 0; i < data.length; i++) {
                    data[i]['JobFunctions'] = data[i]['JobFunctions'].length ? data[i]['JobFunctions'].join(", ") : 'None';
                    data[i]['Seniorities'] = data[i]['Seniorities'].length ? data[i]['Seniorities'].join(", ") : "None";
                    data[i]['Locations'] = data[i]['Locations'].length ? data[i]['Locations'].join(", ") : "None";
                }

                this.setState({data:
                        {...this.state.data,
                            table_data: data,
                            table_loading: false
                        }
                })
            })

    }

    handleFormChange(property, value) {
        this.setState({data: {...this.state.data, audience_size: "Calculating...", [property]: value}}, () => {
            this.fetchAudienceSize();
        });
    }

    handleFormFieldEdit = (e) => {
        const { name, value } = e.target;

        this.setState({data: {...this.state.data, [name]: value}, form_dirty: true});
    }


    onRowClick(state, rowInfo, column, instance) {
        return {
            onClick: e => {
                let rowJobFunctions = rowInfo.row.JobFunctions.split(", ");
                let rowSeniorities = rowInfo.row.Seniorities.split(", ");
                let rowLocations = rowInfo.row.Locations.split(", ");

                this.setState({data: {
                        ...this.state.data,
                        job_functions: rowJobFunctions,
                        seniorities: rowSeniorities,
                        locations: rowLocations,
                        audience_size: rowInfo.row.Size,
                        hide_audience_form: false
                    }
                })
            }
        }
    }

    saveAccount() {
        const requestObj = {
            campaign_id: this.state.data.campaign_id,
            linkedin_company_id: this.state.data.linkedin_company_id,
            job_functions: this.state.data.job_functions,
            seniorities: this.state.data.seniorities,
            locations: this.state.data.locations,
            audience_size: parseInt(this.state.data.audience_size),
            bid_amount: this.state.data.bid_amount
        };

        if (this.state.form_dirty) {
            ApiService.post("/api/campaigns/update-linkedin-company",
                {
                    campaign_id: this.state.data.campaign_id,
                    linkedin_company_id: this.state.data.linkedin_company_id,
                    bid_amount: this.state.data.bid_amount,
                    common_name: this.state.data.common_name,
                    file_identifier: this.state.data.file_identifier,
                    linkedin_url: this.state.data.linkedin_url,
                    account_owner: this.state.data.account_owner,
                    secondary_companies: this.state.data.include_secondary_companies,
                    unique_url: this.state.data.unique_url
                })
                .then(response => {
                    this.updateAccountAudienceOptions(requestObj)
                })
        } else {
            this.updateAccountAudienceOptions(requestObj);
        }

    }

    updateAccountAudienceOptions(requestObj) {
        ApiService.post("/api/campaigns/update-linkedin-company-audience-options", requestObj)
            .then(response => {
                this.props.history.push("/campaignGroup/accounts?client_id="+ this.state.data.client_id
                    + "&campaign_id=" + this.state.data.campaign_id);
            })
            .catch(error => {
                console.log(error);
            });


    }

    toggleSecondaryCompanies = () => {
        let includeSecondaryCompanies = !this.state.data.include_secondary_companies;
        includeSecondaryCompanies = includeSecondaryCompanies? 1 : 0;

        this.setState({data: {...this.state.data,
                include_secondary_companies: includeSecondaryCompanies,
                include_secondary_companies_changed: true,
                audience_size: "Calculating..."
            }
        }, () => {
            ApiService.post('/api/linkedin/audience-size',
                {
                    'linkedin_company_id': this.state.data.linkedin_company_id,
                    'job_functions[]': this.state.data.job_functions,
                    'seniorities[]': this.state.data.seniorities,
                    'locations[]': this.state.data.locations,
                    'client_id': this.state.data.client_id,
                    'campaign_id': this.state.data.campaign_id,
                    'include_secondary_companies': includeSecondaryCompanies
                }).then(response => {
                this.setState({
                    data: {
                        ...this.state.data,
                        audience_size: response.data.size
                    }
                });
            })
        })
    };

    render = () => {

        const columns = [
            {
                Header: "Job Functions",
                accessor: "JobFunctions",
                style: { 'whiteSpace': 'unset' }
            },
            {
                Header: "Seniorities",
                accessor: "Seniorities",
                style: { 'whiteSpace': 'unset' }
            },
            {
                Header: "Locations",
                accessor: "Locations",
                style: { 'whiteSpace': 'unset' }
            },
            {
                Header: "Audience Size",
                accessor: 'Size',
                style: {'whiteSpace': 'unset'}
            },
        ];

        return (
            <div className="page-content">
                <div className="account-container">
                    <div>
                        <b>Account Name: </b> {this.state.data.default_name}
                    </div>

                    <div className="account-field">
                        <div id="common-name-section">
                            <h4>Common Name:</h4>
                            <input id="account-common-name" type="text" name="common_name" value={this.state.data.common_name} onChange={this.handleFormFieldEdit}/>
                        </div>

                        <div id="file-id-section">
                            <h4>File Identifier:</h4>
                            <input id="account-file-id" type="text" name="file_identifier" value={this.state.data.file_identifier} onChange={this.handleFormFieldEdit}/>
                        </div>

                        <div id="linkedin-url-section">
                            <h4>LinkedIn URL:</h4>
                            <input id="account-linkedin-url" type="text" name="linkedin_url" value={this.state.data.linkedin_url} onChange={this.handleFormFieldEdit}/>
                        </div>

                        <div id="account-owner-section">
                            <h4>Account Owner:</h4>
                            <input id="account-owner" type="text" name="account_owner" value={this.state.data.account_owner} onChange={this.handleFormFieldEdit}/>
                        </div>

                        <div>
                            <h4>Unique URL:</h4>
                            <input id="account-unique-url" type="text" name="unique_url" value={this.state.data.unique_url} onChange={this.handleFormFieldEdit}/>
                        </div>
                    </div>
                    <br/>
                    <div>
                        <h4>Version A</h4>
                        <div className="ad-box">
                            <UploadImage version={"A"} imageUrl={this.state.data.image_a_url}/>
                        </div>
                    </div>

                    <div>
                        <h4>Version B</h4>
                        <div className="ad-box">
                            <UploadImage version={"B"} imageUrl={this.state.data.image_b_url}/>
                        </div>
                    </div>
                    <div className="table-style">
                        <ReactTable
                            loading={this.state.data.table_loading}
                            data={this.state.data.table_data}
                            columns={columns}
                            showPagination={false}
                            minRows={0}
                            getTdProps={this.onRowClick.bind(this)}
                        />
                    </div>

                    <div hidden={this.state.data.hide_audience_form}>

                        <AudienceForm data={this.state.data} onFormChange={this.handleFormChange.bind(this)}/>

                        <div>
                            <input  type="checkbox" className="checkbox-field" name="include_secondary_companies" checked={this.state.data.include_secondary_companies} onChange={()=>this.toggleSecondaryCompanies()}/>
                            <span className="checkbox-label">Include Secondary Companies</span>
                        </div>

                        <div className="account-field">
                            <div>
                                <b>Audience Size: </b> {this.state.data.audience_size}
                            </div>
                        </div>
                    </div>

                    <div className="account-field">
                        <div id="bid-amount-section">
                            <h4>Bid Amount</h4>
                            <input id="account-bid-amount" type="number" name="bid_amount" value={this.state.data.bid_amount} onChange={this.handleFormFieldEdit}/>
                        </div>
                    </div>

                    <div className="form-submit">
                        <button type="button" className="outline"
                                onClick = {() => {this.props.history.push("/campaignGroup/accounts?client_id="+ this.state.data.client_id
                                    + "&campaign_id=" + this.state.data.campaign_id)}}>
                            Back
                        </button>
                        <button onClick={this.saveAccount.bind(this)}>Save</button>
                    </div>
                </div>
            </div>
        )}
}

export default Account;
